/* eslint-disable */
const state = {
  selectedPaymentMethod: '',
  selectedHomePaymentMethod: '',
  vgsIndexes: {},
  homeVgsIndexes: {},
  autoRC2Status: '',
  homeRC2Status: '',
  autoBindStatus: '',
  homeBindStatus: '',
  autoLinkButtunStatus: '',
  homeLinkButtunStatus: '',
};

const getters = {
  getSelectedPaymentMethod(state) {
    return state.selectedPaymentMethod;
  },
  getSelectedHomePaymentMethod(state) {
    return state.selectedHomePaymentMethod;
  },
  getVgsIndexes(state) {
    return state.vgsIndexes;
  },
  getHomeVgsIndexes(state) {
    return state.homeVgsIndexes;
  },
  getAutoRC2Status(state) {
    return state.autoRC2Status;
  },
  getHomeRC2Status(state) {
    return state.homeRC2Status;
  },
  getAutoBindStatus(state) {
    return state.autoBindStatus;
  },
  getHomeBindStatus(state) {
    return state.homeBindStatus;
  },
  getAutoLinkButtunStatus(state) {
    return state.autoLinkButtunStatus;
  },
  getHomeLinkButtunStatus(state) {
    return state.homeLinkButtunStatus;
  },
};

const mutations = {
  savePayMethod(state, linkData) {
    state.selectedPaymentMethod = linkData;
  },
  saveHomePaymentMethod(state, linkData) {
    state.selectedHomePaymentMethod = linkData;
  },
  setVgsIndexes(state, obj) {
    state.vgsIndexes = obj;
  },
  setHomeVgsIndexes(state, obj) {
    state.homeVgsIndexes = obj;
  },
  setAutoRC2Status(state, status) {
    state.autoRC2Status = status;
  },
  setHomeRC2Status(state, status) {
    state.homeRC2Status = status;
  },
  setAutoBindStatus(state, status) {
    state.autoBindStatus = status;
  },
  setHomeBindStatus(state, status) {
    state.homeBindStatus = status;
  },
  setAutoLinkButtunStatus(state, status) {
    state.autoLinkButtunStatus = status;
  },
  setHomeLinkButtunStatus(state, status) {
    state.homeLinkButtunStatus = status;
  },
};

const actions = {
  setSelectedPaymentMethod({ commit }, link) {
    commit('savePayMethod', link);
  },
  setSelectedHomePaymentMethod({ commit }, link) {
    commit('saveHomePaymentMethod', link);
  },
  setVgsIndexes({ commit }, obj) {
    commit('setVgsIndexes', obj);
  },
  setHomeVgsIndexes({ commit }, obj) {
    commit('setHomeVgsIndexes', obj);
  },
  setAutoRC2Status(state, status) {
    commit('setAutoRC2Status', status);
  },
  setHomeRC2Status(state, status) {
    commit('setHomeRC2Status', status);
  },
  setAutoBindStatus(state, status) {
    commit('setAutoRC2Status', status);
  },
  setHomeBindStatus(state, status) {
    commit('setHomeBindStatus', status);
  },
  setAutoLinkButtunStatus(state, status) {
    commit('setAutoLinkButtunStatus', status);
  },
  setHomeLinkButtunStatus(state, status) {
    commit('setHomeLinkButtunStatus', status);
  },
};

/**
 * export module to main store.js
 */
export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/checkout.js